import { render, staticRenderFns } from "./MultiProfessionListSelector.vue?vue&type=template&id=28e2af6a&scoped=true&"
import script from "./MultiProfessionListSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiProfessionListSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MultiProfessionListSelector.vue?vue&type=style&index=0&id=28e2af6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e2af6a",
  null
  
)

export default component.exports